import { Component, Inject, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { AppMessageService } from 'src/app/services/app-message.service';

@Component({
  selector: 'occupancy-lov',
  templateUrl: './occupancy-lov.component.html',
  styleUrls: ['./occupancy-lov.component.css']
})
export class OccupancyLovComponent {

  moduleId: string = 'BMM126';
  isBmCode: boolean =false;
  isTariff: boolean =false;
  private selectedData: any;
  public titleLov: string = "OCCUPANCY";

  table: any = {
    cols: [
      {
        key: "occupancyCd",
        header: "Occupancy Code",
        dataType: "string",
        width: '30%'
      },
      {
        key: "occupancyDesc",
        header: "Occupancy",
        dataType: "string"
      },
      {
        key: "tariffCd",
        header: "Tariff Code",
        dataType: "string"
      },
      {
        key: "bmCode",
        header: "BM Code",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  tableBMCode: any = {
    cols: [
      {
        key: "occupancyCd",
        header: "Code",
        dataType: "string",
        width: '30%'
      },
      {
        key: "occupancyDesc",
        header: "Description",
        dataType: "string"
      },
      {
        key: "bmCode",
        header: "BPIMS Code",
        dataType: "string"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  };

  constructor(
    private jsonDataService: JsonDataService,
    private dialogRef: MatDialogRef<OccupancyLovComponent>,
    private _api: APICallService,
    private securityService: SecurityService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    @Inject(MAT_DIALOG_DATA) public fromMainData: any,
  ) {
    if("tableData" in this.fromMainData){
      if(this.fromMainData.tableData == "BM_CODE"){
        this.isBmCode= true;
        this.isTariff=false;
        this.getDataBMCode();
      }else{
        this.isBmCode= false;
        this.isTariff=true;
        this.getData();
      }
    }else{
      this.isBmCode= false;
      this.isTariff=true;
      this.getData();
    }
    if("table" in this.fromMainData){
      this.titleLov = this.fromMainData.table;
    }
  }

  onRowClick(ev: any) {
    try {
      this.selectedData = ev;
    } catch (e) {
    console.error(e);

    }
  }

  private getData(): void {
    try {
      this.table.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getOccupancy({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.moduleId) {
                this.jsonDataService.contorlLoading(false);
                this.table.tblData = content.data.filter((d: any) => {
                  if (d.ACTIVE_TAG === 'A') {
                    d.occupancyCd = d.OCCUPANCY_CD;
                    d.tariffCd = d.TARIFF_CD;
                    d.occupancyDesc = d.OCCUPANCY_DESC;
                    d.bmCode = d.BM_CODE;
                    return true;
                  } else {
                    return false;
                  }
                });
                this.table.loading = false;
              } else {
                this.table.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.table.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.table.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }

  private getDataBMCode(): void {
    try {
      this.tableBMCode.loading = true;
      this.jsonDataService.contorlLoading(true);
      this._api.getOccupancy({
        moduleId: this.fromMainData.moduleId,
        userId: this.userDetailService.userId,
        type: "LOV"
      }).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              let content = JSON.parse(this.jsonDataService.decrypt(data?.response));
              if (content.moduleId === this.moduleId) {
                this.jsonDataService.contorlLoading(false);
                this.tableBMCode.tblData = content.data.filter((d: any) => {
                  if (d.ACTIVE_TAG === 'A') {
                    d.occupancyCd = d.OCCUPANCY_CD;
                    d.tariffCd = d.TARIFF_CD;
                    d.occupancyDesc = d.OCCUPANCY_DESC;
                    d.bmCode = d.BM_CODE;
                    return true;
                  } else {
                    return false;
                  }
                });
                this.tableBMCode.loading = false;
              } else {
                this.tableBMCode.loading = false;
                this.jsonDataService.contorlLoading(false);
                this.appMessageService.showAppMessage("You do not have the correct privilege to access the data. Kindly contact your administrator for assistance.", "error");
              }
            });
          });
        },
        error: (e: any) => {
          this.securityService.checkRequestKeyResponse(e, () => {

            this.tableBMCode.loading = false;
            this.jsonDataService.contorlLoading(false);
            this.appMessageService.showAppMessage(e, "error");
          });
        }
      });
    }
    catch (e) {
    console.error(e);

      this.tableBMCode.loading = false;
      this.jsonDataService.contorlLoading(false);
    }
  }
  onClose(str: string) {
    try {
      if (this.selectedData == '' || this.selectedData == null) {
        this.dialogRef.close({ content: '', button: str });
      }
      else {
        this.dialogRef.close({ content: this.selectedData, button: str });
      }
    } catch (e) {
    console.error(e);

    }
  }

}
